import axios from "axios";
import enUS from "ant-design-vue/lib/locale-provider/en_US";
import idID from "ant-design-vue/lib/locale-provider/id_ID";
export default {
  data(){
    return {
      enUS,
      idID
    }
  },
  methods: {
    onChange(e) {
      const { value } = e.target;
      const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
      if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
        this.value = value;
      }
    },
    onBlur() {
      const { value, onChange } = this;
      if (value.charAt(value.length - 1) === "." || value === "-") {
        onChange({ value: value.slice(0, -1) });
      }
    },
    redirectPandapaKita(context, message) {
      if (
        message === "Invalid API key" ||
        message === "Unauthorized" ||
        message === "Expired API key"
      ) {
        localStorage.removeItem("key_sim_infog");
        window.location = context.$urlPandapaKita;
      }
    },
    ordinalNumber(number) {
      let result = "th";
      this.ordinalnumerik = number.toString();
      if (this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "1") {
        result = "st";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "2"
      ) {
        result = "nd";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "3"
      ) {
        result = "rd";
      } else {
        result = "th";
      }
      return result;
    },
    ordinalNumber(number) {
      let result = "th";
      this.ordinalnumerik = number.toString();
      if (this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "1") {
        result = "st";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "2"
      ) {
        result = "nd";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "3"
      ) {
        result = "rd";
      } else {
        result = "th";
      }
      return result;
    },
    load_icon(type){
      let result  = "file";
      if (type=="application/pdf" || type=="pdf"){
        result = "file-pdf";
      } else if(type=="image/jpeg" || type=="jpg" || type=="jpeg"){
        result = "file-image";
      } else if(type=="application/vnd.ms-excel" || type=="xls" || type=="xlsx"){
        result = "file-excel";
      } else if(type=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        result = "file-excel";
      } else if(type=="application/msword" || type=="doc" || type=="docx"){
        result = "file-word";
      } else if(type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
        result = "file-word";
      } else if(type=="image/png" || type=="png"){
        result = "file-image";
      } else if(type=="application/zip" || type=="zip"){
        result = "file-zip";
      } else if(type=="application/vnd.rar" || type=="rar"){
        result = "file-zip";
      } 
      return result;
    },
    validRatherThenzero(rule, value, callback) {
      if (value == 0) {
        callback('The value must be rather then 0!');
      }else{
        callback();
      }
    },
    validRatherThenOrSamezero(rule, value, callback) {
      if (value < 0) {
        callback('The value must be rather then 0!');
      }else{
        callback();
      }
    },
    isExistsUrlFile(url) {
      //console.log(url)
      axios({
        method: "get",
        url: url,
      })
        .then((response) => {
          console.log(response)
          return true
        })
        .catch(() => {
          return false;
        });
   },
   onlyNumber (event) {
      //console.log(event); //keyCodes value
      
      let keyCode = (event.keyCode ? event.keyCode : event.which);

      // Detecting Ctrl
      var ctrl = event.ctrlKey ? event.ctrlKey : ((keyCode === 17)
      ? true : false);

      if (((//keyCode < 48 ||  
              keyCode > 57)                   // numeric alphabet
          && (keyCode < 96 || keyCode > 105)  // numeric number
         // && keyCode !== 46 // 46 is backspace
          //&& keyCode !== 8  // 8 is delete
          //&& keyCode !== 9  // 8 is Tab
          && keyCode !== 190  // 8 is titik titik separator dibelakang koma / desimal
          && keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
          && keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
          ) 
          && !( (ctrl && keyCode == 65)   // allow ctrl+A
              || (ctrl && keyCode == 67)  // allow ctrl+C
              || (ctrl && keyCode == 86)) // allow ctrl+V
      ) 
      { 

        event.preventDefault();
        
      }else{
        let desimal = event.target.value.split(".");
        if (desimal.length>1
          && keyCode !== 46 // 46 is backspace
          && keyCode !== 8  // 8 is delete
          && keyCode !== 9  // 8 is Tab
          && keyCode !== 65 // ctrl+A
          ){
          if (desimal[1].length==2){
            event.preventDefault();
          }
        }
      }
    },
    currencyIndonesianFormat (event) {
      //console.log(event); //keyCodes value
      
      let keyCode = (event.keyCode ? event.keyCode : event.which);

      // Detecting Ctrl
      var ctrl = event.ctrlKey ? event.ctrlKey : ((keyCode === 17)
      ? true : false);

      if (((//keyCode < 48 ||  
              keyCode > 57)                   // numeric alphabet
          && (keyCode < 96 || keyCode > 105)  // numeric number
         // && keyCode !== 46 // 46 is backspace
          //&& keyCode !== 8  // 8 is delete
          //&& keyCode !== 9  // 8 is Tab
          //&& keyCode !== 190  // 8 is titik titik separator dibelakang koma / desimal
          //&& keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
          && keyCode !== 188 // String koma
          ) 
          && !( (ctrl && keyCode == 65)   // allow ctrl+A
              || (ctrl && keyCode == 67)  // allow ctrl+C
              || (ctrl && keyCode == 86)) // allow ctrl+V
      ) 
      { 

        event.preventDefault();
        
      }else{
        let desimal = event.target.value.split(",");
        if (desimal.length>1
          && keyCode !== 46 // 46 is backspace
          && keyCode !== 8  // 8 is delete
          && keyCode !== 9  // 8 is Tab
          && keyCode !== 65 // ctrl+A
          ){
          if (desimal[1].length==2){
            event.preventDefault();
          }
        }
      }
    },
    getLocalConfigProvider(value){
      let result = this.enUS;
      if (value=='idID'){
        result = this.idID;
      }
      return result;
    },
    UpperEachWord(value){
      let result = "";
      if (value){
        result = value.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
      }
      return result;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    fileTypeFromUrl(file_nm) {
      let typefile = file_nm.substr(file_nm.lastIndexOf("."));
      typefile = typefile.toLowerCase()
          
      if (typefile == ".xls") {
        typefile = "data:application/vnd.ms-excel;base64,";
      } else if (typefile == ".xlsx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      } else if (typefile == ".doc") {
        typefile = "data:application/msword;base64,";
      } else if (typefile == ".docx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
      } else if (typefile == ".pdf") {
        typefile = "data:application/pdf;base64,";
      } else if (typefile == ".jpeg" || typefile == ".jpg") {
        typefile = "data:image/jpeg;base64,";
      } else if (typefile == ".png") {
        typefile = "data:image/png;base64,";
      } else if (typefile == ".zip") {
        typefile = "data:application/zip;base64,";
      } else if (typefile == ".rar") {
        typefile = "data:application/rar;base64,";
      } else if (typefile == ".ppt") {
        typefile = "data:application/vnd.ms-powerpoint;base64,";
      } else if (typefile == ".pptx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,";
      } 
      return typefile
    },
    typeFileFromName(name) {
      return name ? name.substring(name.lastIndexOf(".")+1) : "";
    },
    fileTypeFromUrlBasic(file_nm) {
      let typefile = file_nm.substr(file_nm.lastIndexOf("."));
          
      if (typefile == ".xls") {
        typefile = "application/vnd.ms-excel";
      } else if (typefile == ".xlsx") {
        typefile = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (typefile == ".doc") {
        typefile = "application/msword";
      } else if (typefile == ".docx") {
        typefile = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (typefile == ".pdf") {
        typefile = "application/pdf";
      } else if (typefile == ".jpeg" || typefile == ".jpg") {
        typefile = "image/jpeg";
      } else if (typefile == ".png") {
        typefile = "image/png";
      } else if (typefile == ".zip") {
        typefile = "application/zip";
      } else if (typefile == ".rar") {
        typefile = "application/rar";
      } else if (typefile == ".ppt") {
        typefile = "application/vnd.ms-powerpoint";
      } else if (typefile == ".pptx") {
        typefile = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } 
      return typefile
    },
    formatterIndonesianCurrency(value){
      let temp = value.replace(',','')
      temp = temp.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      temp = temp.replaceAll('.','e')
      temp = temp.replaceAll(',','.')
      temp = temp.replaceAll('e',',')
      return temp
    },
    parserIndonesianCurrency(value){
      value = value.replaceAll(',','e')
      value = value.replaceAll('.','')
      value = value.replaceAll('e','.')
      return value
    },
    async asyncAxiosGet(url, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "get",
              url: process.env.VUE_APP_SERVICEURL + url,
              params: params,
              auth: auth ? {
                  username: auth.username,
                  password: auth.password,
              } : null,
              headers: auth ?{
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              }: null,
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if(response.length)
                  if (response.data.status == false && response.data.message) {
                    this.displayMessageValue("error-other", response.data.message);
                  } else {
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error", responses);
                  }
                reject(err);
              });
          });
    },
    axiosGet(url, auth, params) {
      return new Promise((resolve, reject) => {
          axios({
              method: "get",
              url: process.env.VUE_APP_SERVICEURL + url,
              params: params,
              auth: auth ? {
                  username: auth.username,
                  password: auth.password,
              } : null,
              headers: auth ?{
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              }: null,
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(err);
              });
          });
    },
    async asyncAxiosPost(url, type, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "post",
              url: process.env.VUE_APP_SERVICEURL + url,
              data: params,
              auth: {
                  username: auth.username,
                  password: auth.password,
              },
            headers: type=="formdata" ?
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
              } :
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              } ,
              
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(response);
              });
          });
    },
    async asyncAxiosPut(url, type, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "put",
              url: process.env.VUE_APP_SERVICEURL + url,
              data: params,
              auth: {
                  username: auth.username,
                  password: auth.password,
              },
            headers: type=="formdata" ?
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
              } :
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              } ,
              
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(response);
              });
          });
    },
    async asyncAxiosDelete(url, type, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "delete",
              url: process.env.VUE_APP_SERVICEURL + url,
              data: params,
              auth: {
                  username: auth.username,
                  password: auth.password,
              },
            headers: type=="formdata" ?
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
              } :
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              } ,
              
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(response);
              });
          });
    },
    gotoManifestTrans(that, item){
      let result = ""

      if(item.jenis_transaksi == "payment_schedule" && item.deskripsi == 'Payment Schedule KMK'){
        item.jenis_transaksi = 'payment_schedule_kmk'
      } else if(item.jenis_transaksi == "payment_schedule" && item.deskripsi == 'Payment Schedule Non KMK'){
        item.jenis_transaksi = 'payment_schedule_non_kmk'
      } else if(item.jenis_transaksi == "Adendum - PO" || item.jenis_transaksi == "Adendum - WO"){
        item.jenis_transaksi = 'adendum'
      }

      switch(item.jenis_transaksi) {
			case 'kas_kecil':
				if (
          localStorage.getItem("nvpn") === "/keuangan" ||
          localStorage.getItem("nvpn") === "/keuangan/SpclKasKecil"
        ) {
          result = "SpclKasKecilManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclKasKecilManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclKasKecilManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclKasKecilManifestDir";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclKasKecilManifestVP";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclKasKecilManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKasKecilManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclKasKecilManifestFin";
        } else {
          result = "kaskecilmanifest";
        }
				break;
      case 'klaim_cc_pd':
				if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclMenuMonKlaimCCPDManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclKlaimPDManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclKlaimPDManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclKlaimPDManifestDir";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclMenuMonKlaimCCPDManifestVP";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclMenuMonKlaimCCPDManifestACC";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKlaimPDManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "monitoringManifestKlaimCcPdFin";
        } else if (localStorage.getItem("nvpn") === "/marketing") {
          result = "monitoringManifestKlaimCcPdMar";
        } else {
          result = "SpclKlaimPDManifest_";
        }
				break;
      case 'klaim_cc':
				if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "Spcl_Klaim_Manifest_Cc";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclKlaimCCManifestACC";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "klaim-direktur-pimpro-manifest";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclKlaimCcManifestVP";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKlaimDirekturManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclKlaimCCManifestFin";
        } else {
          result = "KlaimDirekturManifest";
        }
				break;
      case 'klaim_cc_pp':
				if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclKlaimCCPPManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclKlaimPPManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclKlaimPPManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclKlaimPPManifestDir";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclKlaimCCPPManifestACC";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclMenuMonKlaimCCPPManifestVP";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKlaimPPManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclKlaimCCPPManifestFin";
        } else {
          result = "SpclKlaimPPManifest_";
        }
				break;
      case 'klaimdirektur':
				if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclKlaimDirekturManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclKlaimDirekturManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "klaim-direktur-pimpro-manifest";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclKlaimDirekturManifestVer";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKlaimDirekturManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclKlaimDirekturManifestFC";
        } else {
          result = "KlaimDirekturManifest";
        }
				break;
      case 'Account Pay - PO':
        if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "invoice-manifest_Akuntansi";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "invoice-manifest_FC";
        } else {
          result = "invoice-manifest";
        }
        break;
      case 'Account Pay - WO':
        if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "invoice-manifest_Akuntansi";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "invoice-manifest_FC";
        } else {
          result = "invoice-manifest";
        }
        break;
      case 'pi':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclPiManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclPiManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclPiManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclPiManifestFin";
        } else {
          result = "SpclPiManifest_";
        }
        break;
      case 'PP':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclPPManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclPPManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclPPManifestAL";
        } else if (localStorage.getItem("nvpn") === "/purchasing") {
          result = "SpclPPManifest_purchase";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclPPManifestDir";
        } else if (localStorage.getItem("nvpn") === "/ga") {
          result = "SpclPPManifestGA";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclPPManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclPPManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclPPManifestFin";
        } else {
          result = "SpclPPManifest_";
        }
        break;
      case 'PD':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclSPPDManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclSPPDManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclSPPDManifestAL";
        } else if (localStorage.getItem("nvpn") === "/hrd") {
          result = "SpclSPPDManifestHrd";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclSPPDManifestDir";
        } else if (localStorage.getItem("nvpn") === "/sitejakarta") {
          result = "SpclSPPDManifestJkt";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclSPPDManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclSPPDManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclSPPDManifestFin";
        } else if (localStorage.getItem("nvpn") === "/opc/") {
          result = "SpclSPPDManifestOPC";
        } else if (localStorage.getItem("nvpn") === "/marketing") {
          result = "SpclSPPDManifestMar";
        } else {
          result = "SpclSPPDManifest";
        }
        break;
      case 'umpp':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclUMPPManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclUMPPManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclUMPPManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclUMPPManifestDir";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclUMPPManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclUMPPManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclUMPPManifestFin";
        } else if (localStorage.getItem("nvpn") === "/ga") {
          result = "SpclUMPPManifestGA";
        } else {
          result = "SpclUMPPManifest_";
        }
        break;
      case 'umpd':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclUMPDManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclUMPDManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclUMPDManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclUMPDManifestDir";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclUMPDManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclUMPDManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclUMPDManifestFin";
        } else if (localStorage.getItem("nvpn") === "/marketing") {
          result = "SpclUMPDManifestMar";
        }
        break;
      case 'klaimpd':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclKlaimPDManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclKlaimPDManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclKlaimPDManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclKlaimPDManifestDir";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclKlaimPDManifestVP";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclKlaimPDManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKlaimPDManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclKlaimPDManifestFin";
        } else if (localStorage.getItem("nvpn") === "/marketing") {
          result = "SpclKlaimPDManifestMar";
        } else {
          result = "SpclKlaimPDManifest_";
        }
        break;
      case 'klaimpp':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "SpclKlaimPPManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          result = "SpclKlaimPPManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          result = "SpclKlaimPPManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          result = "SpclKlaimPPManifestDir";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          result = "SpclKlaimPPManifestAcc";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          result = "SpclKlaimPPManifestVer";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          result = "SpclKlaimPPManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          result = "SpclKlaimPPManifestFin";
        } else {
          result = "SpclKlaimPPManifest_";
        }
        break;
      case 'adendum':
        if (localStorage.getItem("nvpn") === "/keuangan") {
          result = "invoice-manifest";
        } else{
          result = "invoice-manifest_FC";
        }
        break;
      case 'payment_schedule_kmk':
        if (localStorage.getItem("nvpn") === "/keuangan"){
          result = "penarikan-financing-manifest"
        }else{
          result = "penarikan-financing-manifestFC"
        }
        break;
      case 'payment_schedule_non_kmk':
        item.id = item.id.split('_')[0]
        if (localStorage.getItem("nvpn") === "/keuangan"){
          result = "spclfinancingManifest"
        }else{
          result = "spclfinancingManifestFC"
        }
        break;
			default: result = "empty"; break;
      }

      if(result=="empty"){
        that.displayMessageValue("error-other", 'Manifest Configuration Not Found!');
      }else{
        that.$router.push({
          name: result,
          params: { id: item.id },
        });
      }
    }
  },
};
